import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const FAQ = () => {
  const { t } = useLanguage();

  const faqs = [
    { question: t('faq.q1'), answer: t('faq.a1') },
    { question: t('faq.q2'), answer: t('faq.a2') },
    { question: t('faq.q3'), answer: t('faq.a3') },
    { question: t('faq.q4'), answer: t('faq.a4') },
    { question: t('faq.q5'), answer: t('faq.a5') }
  ];

  return (
    <div className="min-h-screen" data-testid="faq-page">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center bg-cover bg-center"
        style={{ backgroundImage: 'url(https://customer-assets.emergentagent.com/job_premium-workshop-1/artifacts/w7aadprz_Workshop4.png)' }}
      >
        <div className="absolute inset-0 bg-dark-navy/80"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full text-center">
          <h1 className="font-cabinet font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white mb-4">
            {t('faq.title')}
          </h1>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                data-testid={`faq-item-${index}`}
                className="border border-gray-200 px-6"
              >
                <AccordionTrigger className="text-left font-cabinet font-semibold text-lg text-dark-navy hover:text-royal-blue">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base text-gray-600 leading-relaxed pt-2 pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-light-grey">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-cabinet font-bold text-2xl sm:text-3xl text-dark-navy mb-4">
            Still Have Questions?
          </h2>
          <p className="text-base mb-8 text-gray-600">
            Contact us directly for more information
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/contact"
              data-testid="faq-cta-contact"
              className="inline-block px-8 py-3 bg-royal-blue text-white font-cabinet font-bold hover:bg-[#002277] transition-colors"
            >
              {t('nav.contact')}
            </a>
            <a 
              href="https://wa.me/message/EFBOOUUK2AO2K1"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="faq-cta-whatsapp"
              className="inline-block px-8 py-3 bg-whatsapp text-white font-cabinet font-bold hover:bg-[#1EBE5A] transition-colors"
            >
              WhatsApp Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;